<template>
  <div name="choice" :class="{ 'choice-img' : hasImage }">
    <div class="set-img" v-if="hasImage">
      <template v-if="choice.image && foundImage">
        <img class="img-circle" :src="baseURL + filePath.load + choice.image" @error="setImgNotFound()">
      </template>
      <template v-else>
        <img class="img-circle" src="~static/images/no-image-landscape.png">
      </template>
    </div>
    <div :class="'dash-bg-color-skin-light-10 ' + [ hasImage ? 'progress-bg' : 'choice' ]">
      <div class="progress dash-bg-color-skin-dark-10" :style="{ width: progressPercent(choice.number, poll.totalVote) }">
      </div>

      <v-touch class="choosentext cursor-pointer" @doubletap="saveSelectChoice()" title="double click for vote">
        <div class="choose-space">
          <i class="fa fa-check" v-show="choice.selected === 'Y'"></i>
        </div>
        <div class="text">{{ choice.text }}</div>
        <div class="number">{{ choice.number }}</div>
      </v-touch>
    </div>
  </div>
</template>

<script>
import env from 'src/../env.js'

export default {
  name: 'choice',
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/',
      foundImage: true
    }
  },
  props: [ 'index', 'choice', 'poll', 'progressPercent', 'hasImage', 'postSelectChoice', 'filePath' ],
  methods: {
    saveSelectChoice () {
      this.postSelectChoice({ sendParams: this.sendParams(), choiceParams: this.choiceParams() })
    },
    sendParams () {
      return {
        p_codpoll: this.poll.codpoll,
        p_codchoice: this.choice.numseq,
        p_select: this.choice.selected
      }
    },
    choiceParams () {
      return {
        totalVote: this.poll.totalVote,
        codpoll: this.poll.codpoll,
        numseq: this.choice.numseq,
        number: this.choice.number,
        selected: this.choice.selected
      }
    },
    setImgNotFound () {
      this.foundImage = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// choice.vue?39a6d7e9